// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Salesfive_wrapper__10RU-","salesfive":"Salesfive_salesfive__3eZpU","builtBy":"Salesfive_builtBy__3CPYu","logo":"Salesfive_logo__3D9ab"};